import api from "../api/axios";

export const getUsers = async () => {
  try {
    const response = await api.get("/user/group");
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};


export const initiatePhoneVerification = async (user_id, phone) => {
  try {
    const response = await api.post(`/user/${user_id}/phone-verification/`, {phone});
    return response.data;
  } catch (error) {
    console.log('request err', error);
    
    if (error.response) {
      // Add server response details to the error
      error.message = `${error.response.data.message || error.response.data.error || error.response.statusText}`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } 
    throw error;
  }
};

export const verifyOtp = async (user_id, otp) => {
  try {
    const response = await api.post(`/user/${user_id}/verify-phone`, {otp});
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.message || error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};


export const verifyNin = async (user_id, formData) => {
  try {
    const response = await api.post(`/user/${user_id}/verify-nin`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};

export const confirmPhoneVerification = async (user_id) => {
  try {
    const response = await api.get(`/user/${user_id}/confirm-phone-verification`);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};

export const getNin = async (user_id) => {
  try {
    const response = await api.get(`/user/${user_id}/get-nin`);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
};


export const getDashboardData = async () => {
  try {
    const response = await api.get(`/user/dashboard-data`);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
        error.response.data.error || error.response.statusText
      }`;
    } else if (error.request) {
      // Add request details to the error
      error.message = "No response received from server.";
    } else {
      // Add request setup details to the error
      error.message = `${error.message}`;
    }
    throw error;
  }
}; 

export const updateUserProfile = async (payload) => {
  try {
    const response = await api.post('/user/update', payload)
    return response.data;
  } catch (error) {
    if (error.response) {
      // Add server response details to the error
      error.message = `${
       error.response?.data.message || error.response?.statusText ||  error.response?.data?.data 
      }`;
    } 
    throw error;
  }
}